/* eslint-disable react/prop-types */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { EnvironmentThemeProvider } from '@codex/themes';
import { wasPriceDateTrimYear } from '@codex/helpers';
import Rating from '@dc/ui-library/src/molecules/Rating/Rating';
import CompareCheckbox from '../../Compare/CompareCheckbox.jsx';
import ProductChannelsAvailability from './ProductChannelsAvailability.jsx';
import { showFlexibleCreditTooltip, hideFlexibleCreditTooltip }
  from '../../../../appState/ducks/listingPageProducts';
import ProductBriefDescription from './ProductBriefDescription.jsx';
import ProductBriefDescriptionSwitch from './ProductBriefDescriptionSwitch.jsx';
import AddedValueMessagesListing from '../../AddedValueMessages/AddedValueMessagesListing.jsx';
import TariffDetails from '../../TariffDetails/TariffDetails';
import ProductPriceBlockWrapper, { VARIANT_FO_SITE_LISTING_PAGE_LIST }
  from '../../ProductPriceBlock/ProductPriceBlockWrapper.jsx';

class ProductsListItem extends PureComponent {
  constructor(props) {
    super(props);

    this.onFlexibleTooltipClick = this.onFlexibleTooltipClick.bind(this);
  }

  componentWillUnmount() {
    this.props.hideFlexibleCreditTooltip();
  }

  onFlexibleTooltipClick(event) {
    event.preventDefault();
    if (this.props.flexibleCreditTooltipProductID !== this.props.id) {
      this.props.setFlexibleAnchorRefToParent(this.flexibleAnchorRef);
      this.props.showFlexibleCreditTooltip(this.props.id);
    }
  }

  renderOnlineCredit() {
    return (
      <div
        className={'online-credit-message'}
        data-credit-available={this.props.isOnlineCreditAvailable ? true : undefined}
        data-credit-unavailable={this.props.isOnlineCreditAvailable ? undefined : true}
        onClick={(e) => this.onFlexibleTooltipClick(e)}
        ref={(ref) => { this.flexibleAnchorRef = ref; }}
      >
        {this.props.onlineCreditLinkMessage}
      </div>
    );
  }

  renderTariffAlternativeLink() {
    return (
      <div className={'alternative-tariff-link'}>
        <a href={this.props.tariffAlternativeLink.url}>
          {this.props.tariffAlternativeLink.label}
        </a>
      </div>
    );
  }

  renderPromoMessages() {
    const promoMessages = this.props.promoMessages;

    return (
      <>
        {promoMessages.isOnlineOnly && (
          <span className={'label-online-only'}>
            {this.props.translations.onlineOnlyTranslation}
          </span>
        )}

        {promoMessages.badges && (
          <p className={'prd-stickers'}>
            {promoMessages.badges.map((sticker, i) =>
              <img key={i} src={sticker.src} alt={sticker.label} />)}
          </p>
        )}
        {promoMessages.marketingMessages && promoMessages.marketingMessages[0] && (
          <div className={'rad'}>
            <i className={`dcg-icon-${promoMessages.marketingMessages[0].class}`} />
            <strong dangerouslySetInnerHTML={{ __html: promoMessages.marketingMessages[0].text }} />
          </div>
        )}
      </>
    );
  }

  renderTariffDetails() {
    return (
      <TariffDetails details={this.props.tariffDetails} />
    );
  }

  render() {
    const { props } = this;
    const classes = ['product', 'result-prd', 'clearfix'];

    if (props.displayCompare) {
      classes.push('productCompare');
    }

    if (props.stickerImage) {
      classes.push('stamped');
    }

    if (props.hasOurExpertsLoveTag) {
      classes.push('hero-product');
    }

    if (props.comboKitItemsNames) {
      classes.push('obProduct');
    }

    if (props.channelsAvailability.defaultAvailability.canBeDownloaded) {
      classes.push('download');
    }

    return (
      <article
        id={`product${props.id}`}
        className={classes.join(' ')}
        data-interaction={props.dataInteraction}
        data-fupid={props.dataInteraction ? props.id : undefined}
      >
        <strong className={'label-expert'}>
          <div>
            {props.hasOurExpertsLoveTag ? props.translations.ourExpertsLoveTranslation : ' '}
          </div>
        </strong>

        {props.stickerImage && (
          <div className={'sticker stickerImg'}>
            <img
              src={props.stickerImage.src}
              alt={props.stickerImage.alt ? props.stickerImage.alt : undefined}
            />
          </div>
        )}

        <div className={'productWrapper'}>
          <header className={'productTitle'}>
            <a href={props.link}>
              <span data-product={'brand'}>
                {props.brand.title}
                {' '}
              </span>
              <span data-product={'name'}>{props.title}</span>
            </a>
          </header>
          <div className={'productListContainer'}>
            <div className={'productListImage'}>
              <a href={props.link} className={`imgC ${props.icons ? 'hasBadges' : ''}`}>
                <div className={'product-images'}>
                  <img
                    src={props.image.src}
                    className={'image'}
                    alt={props.image.label}
                  />
                </div>
              </a>
              {props.icons && (
                <div className={`badges ${props.displayCompare ? 'compare_b' : ''}`}>
                  {props.icons.map((badge, i) => (
                    <a
                      href={badge.linkUrl ? badge.linkUrl : ''}
                      target={'_blank'}
                      rel={'noopener noreferrer'}
                      key={i}
                    >
                      <img src={badge.imgUrl} alt={''} />
                    </a>
                  ))}
                </div>
              )}
              {/* eslint-disable jsx-a11y/anchor-has-content */}
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <a className={'clickableArea'} href={props.link} />
            </div>
            <div className={'desc'}>
              <a href={props.link}>
                <div className={'in'}>
                  {props.tariffDetails && this.renderTariffDetails()}

                  {props.isFlashSale && (
                    <div
                      className={'countdown-label ' +
                      `${props.countdownClassSuffix ? props.countdownClassSuffix : ''}`}
                      id={`countdown_${props.id}`}
                    >
                      <p>{props.translations.countdownSaleSearchTranslation}</p>
                    </div>
                  )}

                  {this.renderPromoMessages()}

                  {props.comboKitItemsNames &&
                    [
                      <ul key={0} className={'productDescription simple'}>
                        {props.comboKitItemsNames.map((comboKitItemName, i) => (
                          <li key={i} className={'nowrap wide'}>
                            <i className={'dcg-icon-circle-plus'} />
                            {comboKitItemName}
                          </li>
                        ))}
                      </ul>,
                      <h5 key={1} className={'brand'}>{props.comboKitNumberOfItemsMessage}</h5>
                    ]}

                  {!props.comboKitItemsNames && props.descriptionBullets && (
                    <ul className={'productDescription'}>
                      {props.descriptionBullets.map((description, index) =>
                        (<li key={index}>{description}</li>))}
                    </ul>
                  )}

                  {props.promoMessages.dealsAvailable && (
                    <AddedValueMessagesListing
                      view={'list'}
                      data={props.promoMessages.dealsAvailable}
                    />
                  )}

                  {props.review && (
                    <div className={'reevoo-placeholder'}>
                      {props.review.reviewCount > 0
                        ? (
                          <Rating
                            maxCount={5}
                            ratingCount={props.review.reviewCount}
                            ratingValue={props.review.score}
                          />
                        )
                        : <small>{props.translations.noReviewsTranslation}</small>}
                    </div>
                  )}
                </div>
              </a>

              <ProductBriefDescriptionSwitch
                productID={props.id}
              />
            </div>
          </div>
        </div>

        <div className={'productPrices'}>
          <EnvironmentThemeProvider>
            <ProductPriceBlockWrapper
              currentPrice={props.price.price}
              savingsPrice={props.price.savingsPrice}
              wasPrice={props.price.wasPrice}
              wasPriceFrom={props.price.wasPriceFrom
                ? wasPriceDateTrimYear(props.price.wasPriceFrom) : undefined}
              wasPriceTo={props.price.wasPriceTo
                ? wasPriceDateTrimYear(props.price.wasPriceTo) : undefined}
              fromDateTranslation={props.translations.fromDateTranslation}
              toDateTranslation={'-'}
              isOutOfStock={props.isOutOfStock}
              mainProductWasPrice={props.price.mainProductWasPrice}
              mainProductCurrentPrice={props.price.mainProductCurrentPrice}
              separateSellingPrice={props.price.separateSellingPrice}
              mainProductWasPriceTranslation={props.translations.mainProductWasPriceTranslation}
              mainProductCurrentPriceTranslation={
                props.translations.mainProductCurrentPriceTranslation
              }
              separateSellingPriceTranslation={props.translations.separateSellingPriceTranslation}
              inStorePrice={props.price.inStorePrice}
              inStorePriceTranslation={props.inStorePriceTranslation}
              perMonthPrice={props.price.perMonthPrice}
              perMonthTranslation={props.translations.perMonthTranslation}
              isFlashSale={props.isFlashSale}
              countdownSaleTranslation={props.translations.countdownSaleTranslation}
              webExclusivePriceTranslation={props.translations.webExclusivePriceTranslation}
              variant={VARIANT_FO_SITE_LISTING_PAGE_LIST}
            />
          </EnvironmentThemeProvider>

          {props.onlineCreditLinkMessage &&
            this.renderOnlineCredit()}

          {props.tariffAlternativeLink &&
            this.renderTariffAlternativeLink()}

          <ProductChannelsAvailability
            channelsAvailability={props.channelsAvailability}
            id={props.id}
            isOutOfStock={props.isOutOfStock}
            translations={props.translations}
          />

          {props.displayCompare && (
            <CompareCheckbox
              containerFormEl={document.querySelector('form[data-component="compareForm"]')}
              product={props}
              tooltipArrowDirection={'bottom'}
              translations={props.translations.compareCheckboxTranslations}
            />
          )}
        </div>
        {props.briefDescriptionProductID === props.id && (
          <ProductBriefDescription
            icons={props.icons}
            descriptionShortened={props.descriptionShortened}
            link={props.link}
            productDescriptionLinkTranslation={props.translations.productDescriptionLinkTranslation}
          />
        )}
      </article>
    );
  }
}

ProductsListItem.displayName = 'ProductsListItem';

// TODO: add missing price proptypes
ProductsListItem.propTypes = {
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      imgUrl: PropTypes.string.isRequired,
      linkUrl: PropTypes.string
    })
  ),
  briefDescriptionProductID: PropTypes.string,
  channelsAvailability: PropTypes.shape({
    defaultAvailability: PropTypes.shape({
      canBeDownloaded: PropTypes.bool
    })
  }).isRequired,
  comboKitItemsNames: PropTypes.arrayOf(PropTypes.string),
  comboKitNumberOfItemsMessage: PropTypes.string,
  countdownClassSuffix: PropTypes.string,
  displayCompare: PropTypes.bool.isRequired,
  hasOurExpertsLoveTag: PropTypes.bool.isRequired,
  hideFlexibleCreditTooltip: PropTypes.func,
  isFlashSale: PropTypes.bool.isRequired,
  isOnlineCreditAvailable: PropTypes.bool,
  isOutOfStock: PropTypes.bool.isRequired,
  onlineCreditLinkMessage: PropTypes.string,
  tariffAlternativeLink: PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }),
  brand: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired,
  descriptionShortened: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.shape({}).isRequired,
  link: PropTypes.string.isRequired,
  promoMessages: PropTypes.shape({
    dealsAvailable: PropTypes.arrayOf(PropTypes.object),
    isOnlineOnly: PropTypes.bool.isRequired,
    marketingMessages: PropTypes.arrayOf(PropTypes.shape({
      class: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    }).isRequired),
    numberOfDealsAvailableTranslation: PropTypes.string,
    badges: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      src: PropTypes.string.isRequired
    }))
  }).isRequired,
  descriptionBullets: PropTypes.arrayOf(
    PropTypes.string
  ),
  review: PropTypes.shape({
    reviewCount: PropTypes.number.isRequired,
    score: PropTypes.number
  }),
  stickerImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string
  }),
  showFlexibleCreditTooltip: PropTypes.func,
  translations: PropTypes.shape({
    countdownSaleSearchTranslation: PropTypes.string.isRequired,
    noReviewsTranslation: PropTypes.string.isRequired,
    onlineOnlyTranslation: PropTypes.string.isRequired,
    ourExpertsLoveTranslation: PropTypes.string.isRequired,
    productDescriptionLinkTranslation: PropTypes.string.isRequired,
    compareCheckboxTranslations: PropTypes.objectOf(PropTypes.string).isRequired
  }).isRequired,
  setFlexibleAnchorRefToParent: PropTypes.func,
  flexibleCreditTooltipProductID: PropTypes.string,
  dataInteraction: PropTypes.string,
  onProductIntersection: PropTypes.func,
  tariffDetails: PropTypes.shape({
    data: PropTypes.objectOf(PropTypes.string),
    minutes: PropTypes.objectOf(PropTypes.string),
    texts: PropTypes.objectOf(PropTypes.string)
  })
};

ProductsListItem.defaultProps = {
  icons: undefined,
  comboKitItemsNames: undefined,
  comboKitNumberOfItemsMessage: undefined,
  countdownClassSuffix: undefined,
  isOnlineCreditAvailable: false,
  onlineCreditLinkMessage: undefined,
  tariffAlternativeLink: null,
  descriptionBullets: undefined,
  review: undefined,
  stickerImage: undefined,
  briefDescriptionProductID: null,
  showFlexibleCreditTooltip: () => {},
  hideFlexibleCreditTooltip: () => {},
  setFlexibleAnchorRefToParent: () => {},
  flexibleCreditTooltipProductID: null,
  dataInteraction: undefined,
  onProductIntersection: undefined,
  tariffDetails: undefined
};

const mapStateToProps = (state) => ({
  briefDescriptionProductID: state.listingPage.products.briefDescriptionProductID,
  flexibleCreditTooltipProductID: state.listingPage.products.flexibleCreditTooltipProductID
});

const dispatchFunctions = {
  showFlexibleCreditTooltip,
  hideFlexibleCreditTooltip
};

export default connect(mapStateToProps, dispatchFunctions)(ProductsListItem);
